// 受付(intake) × 配車・受注(dispatch) の相互ジャンプ用ユーティリティ。
// 設計: engineering-タクミ/docs/2026-08-25-受付配車受注統合-設計.md（方針5・PR②③）
//
// 統合の第一歩は「一覧の合成」と「導線」であって、フォームやデータの統合ではない
// （requests / trips の2コレクションは維持する＝方針3）。
// ここに置くのは、その合成に必要な純粋関数だけ。DOM・ネットワークには触れない。

// ルータ（src/router.js）はハッシュの `?` 以降をルート判定には使わず、ビュー側が
// location.hash を直接読む作法（main.js の approve/request トークンと同じ）。
// `open` パラメータの抽出もその作法に倣い、ここでは hash 文字列を引数で受け取る
// 純粋関数にする（DOM非依存＝ユニットテスト可能）。
export function openIdFromHash(hash) {
  const h = String(hash == null ? '' : hash)
  const m = h.match(/^#\/?[a-z]+(?:\?(.*))?$/i)
  if (!m) return ''
  return new URLSearchParams(m[1] || '').get('open') || ''
}

const stopsOf = (r) => (Array.isArray(r && r.stops) ? r.stops : [])
const firstPick = (r) => stopsOf(r).find((s) => s && s.role === 'pick') || null
const lastDrop = (r) => { const d = stopsOf(r).filter((s) => s && s.role === 'drop'); return d.length ? d[d.length - 1] : null }
const partOf = (s) => ({ pref: String((s && s.pref) || '').trim(), city: String((s && s.city) || '').trim() })

// requests（未取込＝tripId なし）を、dispatch.js の一覧行と同じシェイプに変換する。
// DBには触れない・表示専用（方針1(c)）。KPI計算には使わないこと（方針2・「仮受付/正式はKPIに混ぜない」の拡張適用）。
export function pendingRequestRow(r) {
  const req = r || {}
  const pick = firstPick(req), drop = lastDrop(req)
  const from = partOf(pick), to = partOf(drop)
  const own = req.kind !== 'charter'
  // _entry: 行の由来。'dispatch'（＋スポット便の手入力・状態一本化 段1）は dispatch モーダルで開き、
  // via も「手入力」表示にする。それ以外（受付フォーム/メール取込）は従来どおり「受付」。
  const entry = req.entry === 'dispatch' ? 'dispatch' : ''
  return {
    _trip: false, _request: true, _entry: entry, id: req.id,
    source: own ? '自社便' : '傭車', via: entry === 'dispatch' ? '手入力' : '受付', staff: req.staff || '',
    shipper: req.customerFormal || req.customerName || '',
    startDate: (pick && pick.date) || req.date || '', startTime: '',
    startPref: from.pref, startCity: from.city, endPref: to.pref, endCity: to.city,
    item: req.item || '', vehReq: req.vehicleClass || '', vehSize: '',
    orderAmount: Number(req.fare) || 0, billToll: Number(req.tollBill) || 0,
    partner: own ? '' : (req.partnerFormal || req.partnerName || ''),
    driver: own ? (req.driverName || '') : (req.driverName || req.youshaDriver || ''),
    vehicle: req.carNo || '', status: req.status === 'formal' ? '正式' : '仮受付', month: req.month || '',
  }
}
